import './alteration-detail-image-popup.scss'

import { PropType } from 'vue';
import Component from "vue-class-component";
import { BModal } from "bootstrap-vue";

import { ReactiveVue } from "@skinsoft/reactive-vue";
import { DeleteImageClickEvent, MediaArea } from "@skinsoft/entity-ui";
import { DELETE_IMAGE_CLICK_TOPIC, IMAGE_CLICK_TOPIC, IMAGE_UPLOADED_TOPIC, MEDIA_END_LOADING_TOPIC, MEDIA_ID_CHANGED_FROM_CACHE, PRINCIPAL_IMAGE_CLICK_TOPIC } from "@skinsoft/bus";
import { ImageTransferHelper } from '@skinsoft/media-transfer-helper';
import { DETAILED_ALTERATION_IMAGE_ADDED } from '../../../../events';

@Component({
    components: {
        sMediaArea: MediaArea
    },
    props: {
        mediaIds: {
            type: Array as PropType<String[]>,
            default: [],
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "alterationDetailImagePopup.title",
        },
    },
    template: require('./alteration-detail-image-popup.html')
})
export class AlterationDetailImagePopup extends ReactiveVue {
    private mediaIds: String[]
    private readOnly: Boolean
    private title: String

    private clickOnMediasAllowed: boolean = true
    private mediaUploadInProgress: boolean = false
    private mediaAreasId: string = ''

    private $imageTransferHelper: ImageTransferHelper

    public $refs: {
        modal: BModal,
    }

    private DELETE_IMAGE_CLICK_TOPIC = DELETE_IMAGE_CLICK_TOPIC
    private IMAGE_UPLOADED_TOPIC = IMAGE_UPLOADED_TOPIC
    private PRINCIPAL_IMAGE_CLICK_TOPIC = PRINCIPAL_IMAGE_CLICK_TOPIC
    private MEDIA_ID_CHANGED_FROM_CACHE = MEDIA_ID_CHANGED_FROM_CACHE
    private IMAGE_CLICK_TOPIC = IMAGE_CLICK_TOPIC

    mounted() {
        this.mediaAreasId = window.performance.now().toString() + Math.random().toString(16).slice(2)
        this.subscribeToBus(MEDIA_END_LOADING_TOPIC, (message => {
            this.clickOnMediasAllowed = true
        }))
    }

    private get computedTitle(): string {
        return this.$t(this.title as string) as string ?? this.title as string
    }

    private onImageUploaded(fileData) {
        // we upload media only in cache, 

        this.clickOnMediasAllowed = false
        const formData = new FormData()
        formData.append("file", fileData.file)

        this.mediaUploadInProgress = true
        // Retrieving temp id and uploading the media on backend asynchronously
        const cacheKey = this.$imageTransferHelper.uploadImageInCache(fileData.file, fileData.url)
        setTimeout(() => { // if no timeout, the DOM may not have the time to update
            this.mediaUploadInProgress = false
        }, 500)

        this.$emit(DETAILED_ALTERATION_IMAGE_ADDED, { cacheKey: cacheKey })
        this.clickOnMediasAllowed = true
    }

    private ondeleteImageClicked(event: DeleteImageClickEvent) {
        if(event.imageId) {
            this.$emit(DELETE_IMAGE_CLICK_TOPIC, event)
        } else {
            if(this.mediaIds.length && this.mediaIds.length >= event.imageListIndex) {
                this.$emit(
                    DELETE_IMAGE_CLICK_TOPIC,
                    {
                        imageListIndex: event.imageListIndex,
                        imageId: this.mediaIds[event.imageListIndex] as string,
                    } as DeleteImageClickEvent
                )
            }
        }
    }

    private onImageClicked() {
        // nothing yet
    }

    public closeModal() {
        this.$refs.modal.hide()
    }

    public openModal() {
        this.$refs.modal.show()
    }
}